<template lang="pug">
  gb-card.member-list
    .list-row
      p.list-item.header 氏名
      p.list-item.header 氏名（カナ）
      p.list-item.header メールアドレス
      p.list-item.header 誕生日
      //p.list-item.header
    .hr-secondary
    .list-row(v-for="member in memberList")
      p.list-item {{ member.staff_name }}
      p.list-item {{ member.staff_name_kana }}
      p.list-item {{ member.email }}
      p.list-item {{ member.birthday }}
      p.button.text-nodisplay
</template>
<script>
import GbCard from '@/components/atoms/GbCard.vue'
import GbButton from '@/components/atoms/GbButton.vue'
export default {
  name: 'MemberListNursery',
  components: {
    GbCard,
    GbButton
  },
  props: {
    memberList: {
      type: Array,
      default: () => { return [] }
    }
  },
  methods: {
  }
}
</script>
<style lang="stylus" scoped>
@import '../../stylus/main.styl'
.member-list
  width 100%
.list-row
  display flex
  flex-direction row
  align-items center
  p
    font-size 12px
.list-item
  flex 1
  color $color-secondary !important
  &.header
    font-weight 400
.text-danger
  margin 0 !important
.text-edit
  margin 0 !important
.text-nodisplay
  font-size 14px
  width 200px
.button
  outline: none;
  border: none;
  margin: 8px;
  height: 30px;
  width: 0px;
  font-size: 16px;
</style>



// WEBPACK FOOTER //
// src/components/organisms/MemberListNursery.vue